import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.warpscript = bracketIndenting()
